<template>
  <div>
    <input-with-validation :vid="randomVid" :disabled="readOnly" :field-label="$attrs.label" :rules="rules" :placeholder="placeholder" b-name="select" v-model="model" expanded>
      <!-- eslint-disable-next-line vue/require-v-for-key -->
      <option v-for="val in choices" :value="val">{{ val }}</option>
    </input-with-validation>
  </div>
</template>

<script>
import InputWithValidation from "@/components/validation/InputWithValidation";
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
export default {
  name: "SelectElementRenderer",
  mixins: [ElementRendererMixin],
  components: {InputWithValidation}
}
</script>

<style scoped>

</style>
